import React, { useState } from "react";

import "./configSection.css";

import ConfigEditor from "./ConfigEditor";
import Hint from "../../utils/Hint/Hint";

const ConfigSection = ({ config, setConfig }) => {
  const [isEdited, setIsEdited] = useState(false);

  const handleUpdateConfiguration = (config) => {
    setConfig({ ...config });
    setIsEdited(false);
  };

  const switchDayName = (day) => {
    switch (day.toString()) {
      case "0":
        return "Sunday";
      case "1":
        return "Monday";
      case "2":
        return "Tuesday";
      case "3":
        return "Wednesday";
      case "4":
        return "Thursday";
      case "5":
        return "Friday";
      case "6":
        return "Saturday";
    }
  };

  return (
    <section className="section configSection">
      <Hint
        hintHeading="Application-level configurations"
        hintText={`
        <div>
        <div>
          The interface for managing application-level configurations. Double-tap or double-click to start editing.
          </div>
          <div>
          Allows to dynamically change operating days and hours, delivery prices, and enable/disable customer-application functionality without a need for a separate specialist or specific technical skills.
          </div>
          <div>
        The actual set of configurations can be adjusted to the business' requirements and the architecture of the customer application.
        </div>  
        </div>
        `}
        openOnMount={false}
        top="5em"
        right="3em"
      />
      {config ? (
        !isEdited ? (
          <div
            className="configSection__configContainer"
            onDoubleClick={() => setIsEdited(true)}
          >
            <div className="configContainer__switchesDiv">
              <h3>CONFIGURATIONS</h3>
              <div>
                <div className="switchesDiv__isOrdersAllowed">
                  <h4>Online orders</h4>
                  <div>{config.isOrdersAllowed ? "on" : "off"}</div>
                </div>
                <div className="switchesDiv__isSMSAllowed">
                  <h4>SMS notifications</h4>
                  <div>{config.isSMSAllowed ? "on" : "off"}</div>
                </div>
                <div className="switchesDiv__isOnlinePaymentAllowed">
                  <h4>Online payment</h4>
                  <div>{config.isOnlinePaymentAllowed ? "on" : "off"}</div>
                </div>
                <div className="switchesDiv__isDeliveryAllowed">
                  <h4>Delivery</h4>
                  <div>{config.isDeliveryAllowed ? "on" : "off"}</div>
                </div>
              </div>
              <div>
                <div className="switchesDiv__freeDeliveryMinPrice">
                  <h4>Min sum for delivery</h4>
                  <div>{config.deliveryOrderMinPrice}&nbsp;$</div>
                </div>
                <div className="switchesDiv__freeDeliveryMinPrice">
                  <h4>Delivery price (zone 1)</h4>
                  <div>{config.deliveryPrice}&nbsp;$</div>
                </div>
                <div className="switchesDiv__freeDeliveryMinPrice">
                  <h4>Delivery price (zone 2)</h4>
                  <div>{config.deliveryPrice2}&nbsp;$</div>
                </div>
                <div className="switchesDiv__freeDeliveryMinPrice">
                  <h4>Min sum for free delivery</h4>
                  <div>{config.freeDeliveryMinPrice}&nbsp;$</div>
                </div>
              </div>
            </div>
            <div className="configContainer__holidaysDiv">
              <h3 style={{ textAlign: "center" }}>HOLIDAYS</h3>
              <div className="holidaysDiv__daysContainer">
                {config.holidays && config.holidays.length
                  ? config.holidays.map((day, index) => (
                      <span key={day}>
                        {switchDayName(day)}
                        {index === config.holidays.length - 1 ? "." : ", "}
                      </span>
                    ))
                  : "Holidays not selected"}
              </div>
            </div>
            <div className="configContainer__TimeInputDiv">
              <h3>TIME CONFIGURATION</h3>
              <div className="TimeInputDiv__operationTime">
                <h4>Restaurant working hours</h4>
                <div className="operationTime__from">
                  <span className="helperSpan">from</span>
                  <span className="timeSpan">{config.operationTimeFrom}</span>
                </div>
                <div className="operationTime__to">
                  <span className="helperSpan">to</span>
                  <span className="timeSpan">{config.operationTimeTo}</span>
                </div>
              </div>
              <div className="TimeInputDiv__orderMake">
                <h4>Order accept</h4>
                <div className="orderMake__from">
                  <span className="helperSpan">from</span>
                  <span className="timeSpan">{config.orderMakeFrom}</span>
                </div>
                <div className="orderMake__eatInTo">
                  <span className="helperSpan">on spot to</span>
                  <span className="timeSpan">{config.orderMakeEatInTo}</span>
                </div>
                <div className="orderMake__takeOutTo">
                  <span className="helperSpan">takeaway to</span>
                  <span className="timeSpan">{config.orderMakeTakeOutTo}</span>
                </div>
              </div>
              <div className="TimeInputDiv__orderGrabEatIn">
                <h4>Order receipt (on spot)</h4>
                <div className="orderGrabEatIn__from">
                  <span className="helperSpan">from</span>
                  <span className="timeSpan">{config.orderGrabEatInFrom}</span>
                </div>
                <div className="orderGrabEatIn__to">
                  <span className="helperSpan">to</span>
                  <span className="timeSpan">{config.orderGrabEatInTo}</span>
                </div>
              </div>
              <div className="TimeInputDiv__orderGrabTakeOut">
                <h4>Order receipt (take away)</h4>
                <div className="orderGrabTakeOut__from">
                  <span className="helperSpan">from</span>
                  <span className="timeSpan">
                    {config.orderGrabTakeOutFrom}
                  </span>
                </div>
                <div className="orderGrabTakeOut__onSpotTo">
                  <span className="helperSpan">on-spot payment to</span>
                  <span className="timeSpan">{config.orderGrabTakeOutTo}</span>
                </div>
                <div className="orderGrabTakeOut__payOnlineTo">
                  <span className="helperSpan">online payment to</span>
                  <span className="timeSpan">
                    {config.orderGrabTakeOutPayOnlineTo}
                  </span>
                </div>
              </div>
              <div className="TimeInputDiv__orderGrabTakeOut">
                <h4>Order receipt (delivery)</h4>
                <div className="orderGrabTakeOut__from">
                  <span className="helperSpan">from</span>
                  <span className="timeSpan">
                    {config.orderGrabTakeOutFrom}
                  </span>
                </div>
                <div className="orderGrabTakeOut__from">
                  <span className="helperSpan">to</span>
                  <span className="timeSpan">{config.orderGrabDeliveryTo}</span>
                </div>
              </div>
            </div>
            <div className="configContainer__controlsDiv">
              <button
                className="controlsDiv__startEditBtn"
                onClick={() => setIsEdited(true)}
              >
                EDIT
              </button>
            </div>
          </div>
        ) : (
          <ConfigEditor
            config={config}
            handleUpdateConfiguration={handleUpdateConfiguration}
            handleCancel={() => setIsEdited(false)}
          />
        )
      ) : (
        <div>Configuration data unavailable</div>
      )}
    </section>
  );
};

export default ConfigSection;
